import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, computed, ref, watch, openBlock, createElementBlock, normalizeClass, unref, createVNode, withCtx, createElementVNode, isRef, normalizeStyle, toDisplayString, createBlock, Fragment, renderList } from 'vue';
import { useStyleConfig } from '../abstract';
import Colors from '../utils/colors';
import { Popover, message } from 'ant-design-vue';
import HsvPanel from './HsvPanel.js';
import { useModelValue } from '../vc-utils';
import AlphaSlider from './AlphaSlider.js';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons-vue';
import Clipboard from 'clipboard';
var _hoisted_1 = ["title"];
var _hoisted_2 = /*#__PURE__*/createElementVNode("path", {
  d: "M505.670887 227.023259c-18.257449-18.161861-35.845778-35.6546-52.956162-52.669396 17.49274-17.49274 34.698713-34.698713 52.764985-52.669396 1.720597-1.720597 4.492671-1.720597 6.213268 0 25.426605 26.191315 51.809097 53.434106 80.007776 82.493083 1.720597 1.720597 4.301493 1.625009 5.830913-0.286766 3.82355-4.970615 6.691212-8.889753 10.036818-12.330948 32.308994-32.595761 64.617989-65.191521 97.309338-97.309338 32.404583-31.831051 70.926846-43.110522 114.324133-28.007501 43.875232 15.294199 70.066547 47.603193 76.088638 93.676966 4.970615 37.661964-10.897116 68.537127-37.088431 94.91962-34.12518 34.316358-67.485651 69.015071-101.132888 103.618194-0.669121 0.669121-1.242654 1.338242-1.911775 2.198541-0.955887 1.242654-0.382355 3.632372 1.338242 5.35297 27.529557 26.860436 54.963526 53.720872 81.823962 80.007776 1.720597 1.720597 1.720597 4.492671 0 6.213268-17.683917 17.683917-34.029592 33.934003-50.470855 50.375266-1.720597 1.720597-4.492671 1.720597-6.213268 0-18.639804-18.735393-38.235496-38.331085-58.117954-58.40472-1.720597-1.720597-4.492671-1.720597-6.308857-0.095589-2.485307 2.389719-4.492671 4.301493-6.500034 6.213268-143.669877 143.765466-287.530932 287.435343-431.200809 431.487575-10.036818 10.132407-20.742757 14.625077-35.081068 14.4339-50.184089-0.573532-100.368178-0.191177-150.552267-0.191177-23.992774 0-34.220769-10.227995-34.220769-34.220769 0-51.809097 0.191177-103.618195-0.095588-155.522881-0.095589-10.61035 3.250017-19.022159 10.61035-26.57367 58.309132-59.360608 116.427086-118.912393 174.54504-178.36859l251.111622-257.038124c3.250017-3.345606 6.404446-6.882389 10.036818-10.897116 1.625009-1.816186 1.52942-4.683848-0.191178-6.404446z m37.375198 46.26495c-113.750601 116.522675-227.883558 233.618882-342.685636 351.193034-1.720597 1.720597-1.720597 4.58826-0.095588 6.404445 39.764916 42.53699 79.147477 84.596035 117.096207 125.22125 1.625009 1.816186 4.397082 1.816186 6.117679 0.095589l351.193033-351.193033c1.720597-1.720597 1.720597-4.492671 0-6.213268L549.163764 273.288209c-1.625009-1.720597-4.397082-1.720597-6.117679 0z",
  "p-id": "4062",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = ["data-clipboard-text"];
var _hoisted_5 = ["onClick"];
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'ColorPicker',
  props: {
    modelValue: {
      type: String
    },
    defaultMode: {
      type: String,
      default: 'HEX'
    },
    useNatureDropper: {
      type: Boolean
    },
    colorPlate: {
      type: Array,
      default: function _default() {
        return ['#ef4444', '#f97316', '#f59e0b', '#eab308', '#84cc16', '#22c55e', '#10b981', '#14b8a6', '#06b6d4', '#0ea5e9', '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7', '#d946ef', '#ec4899'];
      }
    }
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useModelValue = useModelValue(function () {
        return props.modelValue;
      }, function (val) {
        if (val !== props.modelValue) {
          emit('update:modelValue', val);
        }
      }, '#FF0000'),
      color = _useModelValue.value;
    // 基色
    var baseColor = computed({
      get: function get() {
        return '#' + Colors.toHex(color.value).toUpperCase();
      },
      set: function set(val) {
        color.value = parseColorStr(val, alpha.value);
      }
    });
    // 色值字符串
    var parseColorStr = function parseColorStr(color, alpha) {
      if (mode.value === 'HEX') {
        return "#".concat(Colors.toHex(color).toUpperCase()).concat(alpha === 1 ? '' : Math.round(alpha * 255).toString(16).toUpperCase());
      } else {
        var _values = getColorValues(color, alpha, mode.value);
        var name = mode.value.toLowerCase() + (alpha === 1 ? '' : 'a');
        var value = alpha === 1 ? _values.slice(0, 3).join(',') : _values.join(',');
        return "".concat(name, "(").concat(value, ")");
      }
    };
    var _useStyleConfig = useStyleConfig('color-picker'),
      prefixCls = _useStyleConfig.prefixCls;
    var modes = ['HEX', 'RGB', 'HSL', 'HSV'];
    var modeIndex = ref(modes.indexOf(props.defaultMode));
    // 透明度
    var _useModelValue2 = useModelValue(function () {
        return Colors.toRgb(color.value).a;
      }, function (val) {
        color.value = parseColorStr(baseColor.value, val);
      }, 1),
      alpha = _useModelValue2.value;
    var mode = computed(function () {
      return modes[modeIndex.value];
    });
    watch(mode, function () {
      return color.value = parseColorStr(baseColor.value, alpha.value);
    });
    var values = computed(function () {
      return getColorValues(baseColor.value, alpha.value, mode.value);
    });
    var inputColor = ref();
    function openEyeDropper() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore 实验性API，目前只有 chrome/edge 浏览器支持
      if (window.EyeDropper) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var dropper = new window.EyeDropper();
        dropper.open().then(function (res) {
          return color.value = res.sRGBHex.toUpperCase();
        }).catch(function (err) {
          return console.warn(err);
        });
      } else if (props.useNatureDropper) {
        inputColor.value.dispatchEvent(new MouseEvent('click'));
      } else {
        message.warn('您的浏览器不支持拾色器，请使用最新版本的 chrome 或 edge 浏览器');
      }
    }
    function toggleMode() {
      modeIndex.value = (modeIndex.value + 1) % 4;
    }
    var toHexAlpha = function toHexAlpha(val) {
      return Math.round(256 * val).toString(16).toUpperCase();
    };
    var getColorValues = function getColorValues(color, alpha, mode) {
      var fixedAlpha = alpha % 1 === 0 ? alpha : alpha.toFixed(2);
      if (mode === 'HEX') {
        return ['#' + Colors.toHex(color).toUpperCase() + (alpha === 1 ? '' : toHexAlpha(alpha))];
      } else if (mode === 'RGB') {
        var _Colors$toRgb = Colors.toRgb(color),
          r = _Colors$toRgb.r,
          g = _Colors$toRgb.g,
          b = _Colors$toRgb.b;
        return [r, g, b, fixedAlpha];
      } else if (mode === 'HSL') {
        var _Colors$toHsl = Colors.toHsl(color),
          h = _Colors$toHsl.h,
          s = _Colors$toHsl.s,
          l = _Colors$toHsl.l;
        return [(h * 360).toFixed(0), (s * 100).toFixed(0) + '%', (l * 100).toFixed(0) + '%', fixedAlpha];
      } else if (mode === 'HSV') {
        var _Colors$toHsv = Colors.toHsv(color),
          _h = _Colors$toHsv.h,
          _s = _Colors$toHsv.s,
          v = _Colors$toHsv.v;
        return [(_h * 360).toFixed(0), (_s * 100).toFixed(0) + '%', (v * 100).toFixed(0) + '%', fixedAlpha];
      }
      return [];
    };
    var copied = ref(false);
    function onCopy() {
      if (copied.value) {
        return;
      }
      var clipboard = new Clipboard('#copyBtn');
      clipboard.on('success', function () {
        copied.value = true;
        setTimeout(function () {
          return copied.value = false;
        }, 1000);
        clipboard.destroy();
      });
    }
    return function (_ctx, _cache) {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(prefixCls))
      }, [createVNode(unref(Popover), {
        trigger: "click",
        "overlay-class-name": "".concat(unref(prefixCls), "-popover")
      }, {
        content: withCtx(function () {
          return [createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-panel"))
          }, [createVNode(HsvPanel, {
            color: baseColor.value,
            "onUpdate:color": _cache[0] || (_cache[0] = function ($event) {
              return baseColor.value = $event;
            })
          }, null, 8 /* PROPS */, ["color"]), createVNode(AlphaSlider, {
            alpha: unref(alpha),
            "onUpdate:alpha": _cache[1] || (_cache[1] = function ($event) {
              return isRef(alpha) ? alpha.value = $event : null;
            }),
            color: baseColor.value
          }, null, 8 /* PROPS */, ["alpha", "color"]), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-preview"))
          }, [createElementVNode("div", {
            onClick: openEyeDropper,
            class: normalizeClass("".concat(unref(prefixCls), "-dropper"))
          }, [createElementVNode("input", {
            ref_key: "inputColor",
            ref: inputColor,
            class: normalizeClass("".concat(unref(prefixCls), "-dropper-input")),
            type: "color"
          }, null, 2 /* CLASS */), (openBlock(), createElementBlock("svg", {
            t: "1677140506844",
            fill: "currentColor",
            class: normalizeClass("".concat(unref(prefixCls), "-dropper-icon")),
            viewBox: "0 0 890 1024",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "p-id": "4061",
            id: "mx_n_1677140506845",
            width: "16",
            height: "16"
          }, _hoisted_3, 2 /* CLASS */))], 2 /* CLASS */), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-preview-box"))
          }, [createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-preview-box-inner")),
            style: normalizeStyle("background: ".concat(baseColor.value, "; opacity: ").concat(unref(alpha)))
          }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */), createElementVNode("div", {
            onClick: toggleMode,
            class: "color-mode-selector"
          }, toDisplayString(mode.value), 1 /* TEXT */), createElementVNode("div", {
            id: "copyBtn",
            ref: "copyBtn",
            onClick: onCopy,
            "data-clipboard-text": unref(color),
            class: normalizeClass("text-subtext ".concat(copied.value ? 'hover:text-success-500' : 'hover:text-text', " transition-transform cursor-pointer hover:scale-105 text-center ml-2 border-solid border-border border w-6 h-6 rounded-full items-center"))
          }, [copied.value ? (openBlock(), createBlock(unref(CheckOutlined), {
            key: 0,
            class: "text-success-500"
          })) : (openBlock(), createBlock(unref(CopyOutlined), {
            key: 1
          }))], 10 /* CLASS, PROPS */, _hoisted_4)], 2 /* CLASS */), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-color-values"))
          }, [(openBlock(true), createElementBlock(Fragment, null, renderList(values.value, function (item, i) {
            var _mode$value$i;
            return openBlock(), createElementBlock("div", {
              class: normalizeClass("".concat(unref(prefixCls), "-color-values-item"))
            }, [createElementVNode("div", {
              class: normalizeClass("".concat(unref(prefixCls), "-color-values-item-content"))
            }, toDisplayString(item), 3 /* TEXT, CLASS */), createElementVNode("div", {
              class: normalizeClass("".concat(unref(prefixCls), "-color-values-input"))
            }, toDisplayString(mode.value === 'HEX' ? mode.value : (_mode$value$i = mode.value[i]) !== null && _mode$value$i !== void 0 ? _mode$value$i : 'A'), 3 /* TEXT, CLASS */)], 2 /* CLASS */);
          }), 256 /* UNKEYED_FRAGMENT */))], 2 /* CLASS */), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-divider"))
          }, null, 2 /* CLASS */), createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-preset-colors"))
          }, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.colorPlate, function (c) {
            return openBlock(), createElementBlock("div", {
              class: normalizeClass("".concat(unref(prefixCls), "-preset-colors-item")),
              style: normalizeStyle("background-color: ".concat(c, ";")),
              onClick: function onClick($event) {
                return color.value = c.toUpperCase();
              }
            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_5);
          }), 256 /* UNKEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */)];
        }),

        default: withCtx(function () {
          return [createElementVNode("div", {
            title: unref(color),
            class: normalizeClass("".concat(unref(prefixCls), "-trigger text-xs overflow-hidden"))
          }, [createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-trigger-inner flex-grow-0 flex-shrink-0 "))
          }, [createElementVNode("div", {
            class: normalizeClass("".concat(unref(prefixCls), "-trigger-inner-color")),
            style: normalizeStyle("background-color: ".concat(baseColor.value, ";opacity: ").concat(unref(alpha)))
          }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */), createElementVNode("span", {
            class: normalizeClass("".concat(unref(prefixCls), "-color-value"))
          }, toDisplayString(unref(color)), 3 /* TEXT, CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["overlay-class-name"])], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var ColorPicker = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/color-picker/ColorPicker.js"]]);
export { ColorPicker as default };